import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chess-championship-under-eleven-fifteen',
  templateUrl: './chess-championship-under-eleven-fifteen.component.html',
  styleUrls: ['./chess-championship-under-eleven-fifteen.component.scss']
})
export class ChessChampionshipUnderElevenFifteenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
